import { CARD_ELEMENT_TEXT_VARIABLE } from '../services/cards/constants';

export const CUSTOM_MESSAGE_TYPE_ENUM = {
  MATCH: 'MATCH',
};

export const CUSTOM_MESSAGE_CHARACTER_LIMIT = 200;

export const CUSTOM_MESSAGE_EMAIL_BODY_CHARACTER_LIMIT = 1200;

export const CUSTOM_MESSAGE_CHANNEL = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};

export const CUSTOM_MESSAGE_PLACEHOLDERS = [
  '{greeting}',
  '{galleryName}',
  '{organizationName}',
  '{identityNames}',
];

export const CUSTOM_MESSAGE_PLACEHOLDER_CONFIG = {
  '{greeting}': {
    label: 'Greeting',
    tooltip:
      "Personalizes the message by including a greeting with the user's first name ('Hi {firstName}') when available, otherwise shows 'Hi there'",
    allowMultiple: false,
    prepend: true,
  },
  '{galleryName}': {
    label: 'Gallery name',
    allowMultiple: true,
  },
  '{organizationName}': {
    label: 'Organization name',
    allowMultiple: true,
  },
  '{identityNames}': {
    label: 'Member names',
    allowMultiple: true,
  },
  [CARD_ELEMENT_TEXT_VARIABLE.IDENTITY_FIRST_NAME]: {
    label: 'Recipient first name',
    tooltip:
      "Replaced with each recipient's first name when the card is printed",
    allowMultiple: true,
  },
};

export const CUSTOM_MESSAGE_GALLERY_NAME_PLACEHOLDER = '{galleryName}';

// The Waldo default as a pseudo custom message for previews. `id: null` is the
// signal for "no custom message".
export const WALDO_FIRST_MATCH_MESSAGE = {
  id: null,
  name: 'Waldo Default',
  body: '{greeting}!\n\n{organizationName} has partnered with Waldo to deliver your photos of {identityNames} at {galleryName}! View and purchase them here:',
  // Client-side copy of the subject the backend sends for the Waldo default.
  email_subject:
    'View and purchase your photos of {identityNames} at {galleryName}',
  email_body: null,
};

export const WALDO_MATCH_MESSAGE_TEMPLATE = {
  value: 'WALDO_DEFAULT',
  label: WALDO_FIRST_MATCH_MESSAGE.name,
  name: WALDO_FIRST_MATCH_MESSAGE.name,
  email_subject: WALDO_FIRST_MATCH_MESSAGE.email_subject,
  body: WALDO_FIRST_MATCH_MESSAGE.body,
};
